import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar from "../Components/Navbar";
import { makeStringNames } from "../Components/MakeStringCollection";
import { classNames } from "../Components/ClassNameCollections";

const Search = () => {
  const [yachts, setYachts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [make, setMake] = useState("HCB");
  const [condition, setCondition] = useState("All");
  const [className, setClassName] = useState("All");
  const [minLength, setMinLength] = useState("");
  const [maxLength, setMaxLength] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [minYear, setMinYear] = useState("");
  const [maxYear, setMaxYear] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = () => {
    setLoading(true);
    setError(null);

    const params = new URLSearchParams();
    const limit = 15;
    params.append("limit", limit);
    params.append("page", page);

    if (make && make !== "All") params.append("brand", make);
    if (condition && condition !== "All") params.append("condition", condition);
    if (className && className !== "All") params.append("category", className);
    if (minPrice || maxPrice)
      params.append("price", `${minPrice || 0},${maxPrice || 999999999}`);
    if (minLength || maxLength)
      params.append("length", `${minLength || 0},${maxLength || 999}`);
    if (minYear || maxYear)
      params.append("year", `${minYear || 1900},${maxYear || 3000}`);

    const apiUrl = `https://americanyachtgroupinternational.com/api/documents?priority_brokerage=40000836&${params.toString()}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        const yachtsArray = data?.yacht_data?.["V-Data"] || [];
        setYachts(yachtsArray);

        const totalItems = data?.yacht_data?.total || 0;
        setTotalPages(Math.ceil(totalItems / limit));

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching yachts:", error);
        setError("Failed to load yachts.");
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, [page]);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
    setPage(1);
  };

  const handlePrevPage = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  return (
    <div style={{ backgroundColor: "#f4f4f4" }}>
      <NavBar />
      <div
        style={{
          // background:
          //   "radial-gradient(ellipse at 50% -50%, #6c94ff 0, #000 100%)",
          height: "100px",
        }}
      ></div>

      <Container fluid className="py-3">
        <Form onSubmit={handleSubmit}>
          <Row className="g-1">
            {/* Make */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group controlId="makeSelect">
                <Form.Label className="mb-0">Make</Form.Label>
                <Form.Control
                  className="rounded-0"
                  as="select"
                  value={make}
                  onChange={(e) => {
                    setMake(e.target.value);
                    setClassName("All");
                  }}
                >
                  <option value="All">All</option>
                  {makeStringNames.map((make) => (
                    <option key={make} value={make}>
                      {make}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            {/* Condition */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group controlId="conditionSelect">
                <Form.Label className="mb-0">Condition</Form.Label>
                <Form.Control
                  className="rounded-0"
                  as="select"
                  value={condition}
                  onChange={(e) => setCondition(e.target.value)}
                >
                  <option value="All">All</option>
                  <option value="new">New</option>
                  <option value="used">Used</option>
                </Form.Control>
              </Form.Group>
            </Col>

            {/* Class Name */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group controlId="classNameSelect">
                <Form.Label className="mb-0">Class Name</Form.Label>
                <Form.Control
                  className="rounded-0"
                  as="select"
                  value={className}
                  onChange={(e) => {
                    setClassName(e.target.value);
                    setMake("All");
                  }}
                >
                  <option value="All">All</option>
                  {classNames.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            {/* Length */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group className="mb-3" controlId="lengthInput">
                <Form.Label className="mb-0">Length</Form.Label>
                <Row className="g-0">
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="min"
                      value={minLength}
                      onChange={(e) => setMinLength(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="max"
                      value={maxLength}
                      onChange={(e) => setMaxLength(e.target.value)}
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Col>

            {/* Year */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group className="mb-3" controlId="yearInput">
                <Form.Label className="mb-0">Year</Form.Label>
                <Row className="g-0">
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="min"
                      value={minYear}
                      onChange={(e) => setMinYear(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="max"
                      value={maxYear}
                      onChange={(e) => setMaxYear(e.target.value)}
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Col>

            {/* Price */}
            <Col xs={12} md={4} lg={2}>
              <Form.Group className="mb-3" controlId="priceInput">
                <Form.Label className="mb-0">Price</Form.Label>
                <Row className="g-0">
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="min"
                      value={minPrice}
                      onChange={(e) => setMinPrice(e.target.value)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      className="rounded-0"
                      type="text"
                      placeholder="max"
                      value={maxPrice}
                      onChange={(e) => setMaxPrice(e.target.value)}
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>

          <div className="text-center">
            <Button
              className="btn-sm border-0 custom-contact-btn p-2 "
              type="submit"
            >
              <i className="fa-solid fa-magnifying-glass"></i> Advanced Search
            </Button>
          </div>
        </Form>
      </Container>

      {loading && (
        <div className="text-center">
          <Spinner animation="border" variant="warning" />
        </div>
      )}
      {error && (
        <div className="text-center text-danger">
          <p>{error}</p>
        </div>
      )}

      <Container fluid className="col-lg-11 py-3">
        {yachts.length === 0 && !loading && !error ? (
          <div className="text-center">
            <p>No results found</p>
          </div>
        ) : (
          <>
            <Row className="g-3">
              {yachts.map((yacht) => (
                <Col xs={12} md={6} lg={4} key={yacht.ID}>
                  <Link to={`/yachtdetails/${yacht.ID}`}>
                    <div
                      className="card border-0"
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                      }}
                    >
                      <img
                        src={
                          yacht.DisplayPicture?.Large ||
                          yacht.DisplayPicture?.Medium
                        }
                        className="card-img-top"
                        alt={yacht.Model}
                        loading="lazy"
                        height="260px"
                      />
                      <div className="card-body p-2">
                        <h5 className="fw-bold mb-1">
                          {yacht.Manufacturer}{" "}
                          <span className="text-dark">{yacht.Model}</span>
                        </h5>
                        <p className="text-dark mb-0">
                          {yacht.Year} | {yacht.City}, {yacht.State},{" "}
                          {yacht.Country}
                        </p>
                        <p className="fw-bold">
                          {yacht.PriceHidden
                            ? "$ Call For Price"
                            : yacht.PriceUSD != null
                            ? new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }).format(yacht.PriceUSD)
                            : "$ Not Available"}
                        </p>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            <div className="d-flex justify-content-center py-4">
              <div className="btn-group" role="group" aria-label="Pagination">
                <button
                  type="button"
                  className="btn border-0 custom-contact-btn fw-bold p-2 fs-6"
                  onClick={handlePrevPage}
                  disabled={page === 1}
                >
                  <i className="fa-solid fa-angles-left"></i> Prev
                </button>
                <button
                  type="button"
                  className="btn border-0 custom-contact-btn p-2 fs-6"
                >
                  Page {page} of {totalPages}
                </button>
                <button
                  type="button"
                  className="btn border-0 custom-contact-btn fw-bold p-2 fs-6"
                  onClick={handleNextPage}
                  disabled={page === totalPages}
                >
                  Next <i className="fa-solid fa-angles-right"></i>
                </button>
              </div>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default Search;
